// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__307i5","legacyBtn":"MutateMid_legacyBtn__2mW_z"};